import { gt as GT } from '~/locale'

export const getRestaurantPageTabs = ({ gt, hasReservablesWithMenus }: { gt: typeof GT; hasReservablesWithMenus: boolean }) => {
  return [
    {
      label: gt.tp('RestaurantPage', 'Menu'),
      id: 'menu',
      visible: hasReservablesWithMenus,
      hash: '#menu',
    },
    {
      label: gt.tp('RestaurantPage', 'Restaurant description'),
      id: 'description',
      hash: '#description',
    },
    {
      label: gt.tp('RestaurantPage', 'Features'),
      id: 'features',
      hash: '#features',
    },
    {
      label: gt.tp('RestaurantPage', 'Location'),
      id: 'location',
      hash: '#location',
    },
  ].filter(isTabVisible)
}

const isTabVisible = (tab: { visible?: boolean }) => tab.visible || !('visible' in tab)
